import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 15, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L13 13.5", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 1.5L1 13.5", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
